import "./style.scss";

import * as Yup from "yup";

import Button, { Button_Style, Button_Type } from "shared/ui/Button/Button";
import React, { useEffect, useState } from "react";
import { auth, firebase } from "shared/config/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as IconBack } from "assets/img/icons/icon_arrow-Left.svg";
import { ReactComponent as IconNext } from "assets/img/icons/icon_arrow-Right.svg";
import { ReactComponent as IconCheck } from "assets/img/icons/icon_status-Checked.svg";

import Alert from "shared/ui/Alert";
import Checkbox from "shared/ui/Checkbox";
import ConfirmPhone from "components/ConfirmPhone";
import IndicatifPhone from "shared/ui/IndicatifPhone";
import Input from "shared/ui/Input/Input";
import Loader from "shared/ui/Loader";
import { useFormik } from "formik";
import { checkReferralCode } from "features/account";
import TermsAgreement from "components/TermsAgreement";
import { ASSISTANCE_PRICING } from "shared/config/pricings";
import { FranceIdentiteSso } from "components/FranceIdentiteSSO/FranceIdentiteSSO";

interface RegisterFormProps {
    showConfirmEmail: (value: boolean) => void;
    setConfirmEmailMessage: (value: string) => void;
    referralCode?: string;
    isNewUserFromWordpressAccompaniment?: boolean;
    offreIdFromWordpress?: number;
}

const RegisterForm: React.FC<RegisterFormProps> = ({ showConfirmEmail, setConfirmEmailMessage, referralCode, isNewUserFromWordpressAccompaniment = false, offreIdFromWordpress }) => {
    const [final, setfinal] = useState<firebase.auth.ConfirmationResult | null>(null); //The final result of the sendOTP request
    const [showConfirmPhone, setshowConfirmPhone] = useState(false); //A boolean value that indicates the register or confirmphone componnent is visible
    const [recaptcha, setRecaptcha] = useState<firebase.auth.ApplicationVerifier>();
    let verifier: any = null;
    const [errorMessage, setErrorMessage] = useState("");
    const [userType, setUserType] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [phonePrefix, setPhonePrefix] = useState("+33");
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [userLastAccompanimentPaid, setUserLastAccompanimentPaid] = useState<any>(ASSISTANCE_PRICING[1]);


    const [steps, setSteps] = useState([
        { isCurrent: true, isDone: false }, // // STEP du champ Nom & prenom
        { isCurrent: false, isDone: false }, // STEP du champ email & phoneNumber
        { isCurrent: false, isDone: false }, // STEP du password & confirmPassword
    ]);

    const [isGoodReferralCode, setIsGoodReferralCode] = useState(true);

    useEffect(() => {
        if (referralCode) {
            checkReferralCodeExistence(referralCode).then(r => {});
        }
    }, [referralCode]);

    const handlePreviousStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep > 0) {
            handleUpdateStep(currentStep - 1);
        }
    };

    useEffect(() => {
        const getOffer = async () => {
            try {
                ASSISTANCE_PRICING.map((offer) => {
                    if (offreIdFromWordpress === offer.offreId) {
                        setUserLastAccompanimentPaid(offer);
                    }
                })
            } catch (error) {
                console.log(error);
            }
        };

        if (offreIdFromWordpress) {
            getOffer();
        }
    }, [offreIdFromWordpress]);


    const handleUpdateStep = (step: number) => {
        setSteps(
            steps.map((s, index) => {
                if (index === step) {
                    return { isCurrent: true, isDone: false };
                } else if (index < step) {
                    return { isCurrent: false, isDone: true };
                }
                return { isCurrent: false, isDone: false };
            }),
        );
    };

    const handleNextStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep < steps.length - 1) {
            handleUpdateStep(currentStep + 1);
        }
    };

    const checkReferralCodeExistence = async (referralCode?: string) => {
        if (referralCode) {
            setIsLoading(true);
            setErrorMessage("");
            const response = await checkReferralCode(referralCode);
            if (response) {
                setIsGoodReferralCode(true);
            } else {
                setErrorMessage("Code de parrainage non trouvé.");
                setIsGoodReferralCode(false);
            }
            setIsLoading(false);
        }
    };


    const validationSchema = Yup.object({
        firstname: Yup.string()
            .min(2, "Le prénom doit contenir au moins 2 caractères.")
            .max(50, "Le prénom ne peut pas dépasser 50 caractères.")
            .matches(
                /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$/,
                "Seules les lettres, espaces, tirets, apostrophes et accents sont autorisés.",
            )
            .required("Le prénom est requis"),
        lastname: Yup.string()
            .min(2, "Le nom doit contenir au moins 2 caractères.")
            .max(20, "Le nom ne peut pas dépasser 20 caractères.")
            .matches(
            /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$/,
            "Seules les lettres, espaces, tirets, apostrophes et accents sont autorisés.",
            )
            .required("Le nom est requis"),
    });

    const validationSchemaStep2 = Yup.object({
        email: Yup.string().email("Email invalide").required("L'email est requis"),
        phoneNumber: Yup.string()
            .matches(/^([0-9][0-9]{8,9})$/, "Numéro de téléphone invalide")
            .required("Le téléphone est requis"),
    });

    const validationSchemaStep3 = Yup.object({
        password: Yup.string()
            .min(8, "Le mot de passe doit contenir au moins 8 caractères.")
            .matches(/[a-zA-Z]/, "Le mot de passe doit contenir au moins une lettre.")
            .matches(/[0-9]/, "Le mot de passe doit contenir au moins un chiffre.")
            .matches(/[\W_]/, "Le mot de passe doit contenir au moins un caractère spécial (&, @, #, %, !, ?, etc.).")
            .required("Veuillez entrer un mot de passe."),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password")], "Les mots de passe doivent correspondre")
            .required("Le mot de passe de confirmation est requis"),
    });

    const [RegistrationData, setRegistrationData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        phoneNumber: "",
        type: "",
        companyName: "",

        isNewUserFromWordpressAccompaniment: isNewUserFromWordpressAccompaniment,
        offreIdFromWordpress: offreIdFromWordpress,
    });
    const generateCaptcha = async () => {
        try {
            if (!verifier) {
                verifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
                    "expired-callback": function () {
                        setErrorMessage("Le captcha a expiré. SVP merci de recharger la page et essayer de nouveau.");
                    },
                });
                await verifier.verify();
                setRecaptcha(verifier);
                setErrorMessage("");
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (steps[2].isCurrent) {
            generateCaptcha();
        }
    }, [steps]);
    useEffect(() => {
        const hasProfessionnels = location.pathname.includes("professionnels");
        setUserType(hasProfessionnels ? "partner" : "individual");
    }, [location]);

    const formik = useFormik({
        initialValues: {
            firstname: "",
            lastname: "",
            companyName: "",
            fromReferralCode: referralCode,
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true);
            try {
                if (userType === "individual") {
                    let {companyName, ...data } = values;
                    if (!isGoodReferralCode) {
                        data.fromReferralCode = undefined;
                    }
                    setRegistrationData({ ...RegistrationData, ...data });
                    // const response = await register(data);
                    // setConfirmEmailMessage(response.success);
                } else {
                    let { ...data } = values;
                    setRegistrationData({ ...RegistrationData, ...data });
                    // const response = await register(data);
                    // setConfirmEmailMessage(response.success);
                }
                handleNextStep();
                setIsLoading(false);
            } catch (error: any) {
                setIsLoading(false);
                if (error.message === "Network Error") {
                    setErrorMessage("Erreur réseau, veuillez réessayer plus tard.");
                } else {
                    setErrorMessage(error.response.data.error);
                }
            }
        },
    });

    const formikStep2 = useFormik({
        initialValues: {
            email: "",
            phoneNumber: "",
        },
        validationSchema: validationSchemaStep2,
        onSubmit: async (values) => {
            setIsLoading(true);
            try {
                // values.phoneNumber = getFullPhoneNumber(values.phoneNumber);
                let { ...data } = values;
                setRegistrationData({ ...RegistrationData, ...data });
                setIsLoading(false);
                handleNextStep();
                // console.log(RegistrationData);
            } catch (error: any) {
                setIsLoading(false);
                if (error.message === "Network Error") {
                    setErrorMessage("Erreur réseau, veuillez réessayer plus tard.");
                } else {
                    setErrorMessage(error.response.data.error);
                }
            }
        },
    });

    const formikStep3 = useFormik({
        initialValues: {
            password: "",
            confirmPassword: "",
            type: userType,
        },
        validationSchema: validationSchemaStep3,
        onSubmit: async (values) => {
            setIsLoading(true);
            try {
                values.type = userType;

                let { confirmPassword, ...data } = values;
                setRegistrationData({ ...RegistrationData, ...data });

                await SendOtp(formikStep2.values.phoneNumber);
                setIsLoading(false);
            } catch (error: any) {
                setIsLoading(false);
                if (error.message === "Network Error") {
                    setErrorMessage("Erreur réseau, veuillez réessayer plus tard.");
                } else {
                    setErrorMessage(error.response.data.error);
                }
            }
        },
    });

    const getFullPhoneNumber = (phoneNumber: string) => {
        if (phonePrefix.includes('33')) {
            if (phoneNumber.charAt(0) === "0") {
                phoneNumber = phoneNumber.substr(1);
            }
        }
        const fullPhoneNumber = `${phonePrefix}${phoneNumber}`;
        return fullPhoneNumber;
    };
    // Send OTP
    const SendOtp = async (phoneNumber: string) => {
        const fullPhoneNumber = getFullPhoneNumber(phoneNumber);
        setIsLoading(true);
        try {
            if (fullPhoneNumber === "" || fullPhoneNumber.length < 10) return;
            if (recaptcha) {
                const result = await auth.signInWithPhoneNumber(fullPhoneNumber, recaptcha);
                //verifier.clear();
                setIsLoading(false);
                setfinal(result); // Mise à jour de l'état
                setshowConfirmPhone(true); // Affiche l'UI de confirmation du numéro de téléphone
            }
        } catch (error: any) {
            console.log(error);
            setIsLoading(false);
            setErrorMessage(error.message);
        }
    };

    return (
        <>
            {!showConfirmPhone ? (
                <>
                    <div>
                        <div className="card">
                            <h5>Espace {userType === "individual" ? "Particuliers" : "Professionnels"}</h5>
                            <h2>Inscription</h2>
                            {isNewUserFromWordpressAccompaniment && (
                              <h5 className={"text-danger text-center text-initial"}>Suite à votre souscription <span
                                className={"text-danger bold"}>{userLastAccompanimentPaid?.title}</span></h5>
                            )}

                            {!errorMessage && steps[0].isCurrent && referralCode && <Alert type="info">Code de parrainage : {referralCode}</Alert>}
                            {errorMessage && <Alert type="error">{errorMessage}</Alert>}
                            {steps[0].isCurrent && (
                                <form onSubmit={formik.handleSubmit}>
                                    <Input
                                        required={true}
                                        type="text"
                                        id="firstname"
                                        name="firstname"
                                        placeholder="Votre prénom"
                                        onChange={formik.handleChange}
                                        value={formik.values.firstname}
                                        onBlur={formik.handleBlur}
                                        errorMessage={formik.touched.firstname && formik.errors.firstname ? formik.errors.firstname : ""}
                                    />
                                    <Input
                                        required={true}
                                        type="text"
                                        id="lastname"
                                        name="lastname"
                                        placeholder="Votre nom"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastname}
                                        errorMessage={formik.touched.lastname && formik.errors.lastname ? formik.errors.lastname : ""}
                                    />
                                    {userType === "partner" && (
                                        <Input
                                            required={true}
                                            type="text"
                                            id="companyName"
                                            name="companyName"
                                            placeholder="Nom de l'entreprise"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.companyName}
                                            errorMessage={formik.touched.companyName && formik.errors.companyName ? formik.errors.companyName : ""}
                                        />
                                    )}

                                    <div
                                        className={`mt-1 d-flex justify-content-${!steps[0].isCurrent ? "between" : "center"} w-100`}>
                                        {!steps[0].isCurrent && (
                                            <Button
                                                className="font-S"
                                                label={"Retour"}
                                                onClick={() => handlePreviousStep()}
                                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                                style={Button_Style.OUTLINED}
                                                icon={<IconBack className="PageHeader__icon" fill={"#ffffff"} />}
                                            />
                                        )}
                                        <Button
                                            buttonType={"submit"}
                                            label={"S'inscrire"}
                                            type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                            disabled={!formik.isValid && formik.dirty}
                                            // icon={<IconNext className="PageHeader__icon" fill={"#ffffff"} />}
                                            className={"w-100 text-sm d-flex justify-content-center align-items-center"}
                                        />
                                    </div>

                                    {userType !== "partner" && (
                                      <>
                                          {/*France Identité SSO here*/}
                                          <FranceIdentiteSso text={"ou créer un compte avec :"}/>
                                      </>
                                    )}

                                </form>
                            )}
                            {steps[1].isCurrent && (
                                <form onSubmit={formikStep2.handleSubmit}>
                                    <Input
                                        required={true}
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="email"
                                        onChange={formikStep2.handleChange}
                                        onBlur={formikStep2.handleBlur}
                                        value={formikStep2.values.email}
                                        errorMessage={formikStep2.touched.email && formikStep2.errors.email ? formikStep2.errors.email : ""}
                                    />

                                    <div className="d-flex gap-1 align-items-center">
                                        <IndicatifPhone
                                            setPhonePrefix={setPhonePrefix}
                                            value={phonePrefix}
                                        />
                                        <Input
                                            required={true}
                                            type="tel"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            placeholder="Téléphone"
                                            onChange={formikStep2.handleChange}
                                            onBlur={formikStep2.handleBlur}
                                            value={formikStep2.values.phoneNumber}
                                            errorMessage={formikStep2.touched.phoneNumber && formikStep2.errors.phoneNumber ? formikStep2.errors.phoneNumber : ""}
                                        />
                                    </div>

                                    <div
                                        className={`mt-1 d-flex justify-content-${!steps[0].isCurrent ? "between" : "center"} w-100`}>
                                        {!steps[0].isCurrent && (
                                            <Button
                                                className="m-auto mb-1 font-S"
                                                label={"Retour"}
                                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                                onClick={() => handlePreviousStep()}
                                                style={Button_Style.OUTLINED}
                                            />
                                        )}
                                        <Button
                                            className="m-auto mb-1"
                                            buttonType={"submit"}
                                            label={"Suivant"}
                                            type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                            disabled={(!formikStep2.isValid && formikStep2.dirty)}
                                            icon={<IconNext className="PageHeader__icon" fill={"#ffffff"} />}
                                        />
                                    </div>
                                </form>
                            )}

                            {steps[2].isCurrent && (
                                <form onSubmit={formikStep3.handleSubmit}>
                                    <Input
                                        required={true}
                                        type="password"
                                        id="password"
                                        name="password"
                                        placeholder="Mot de passe"
                                        onChange={formikStep3.handleChange}
                                        onBlur={formikStep3.handleBlur}
                                        value={formikStep3.values.password}
                                        errorMessage={formikStep3.touched.password && formikStep3.errors.password ? formikStep3.errors.password : ""}
                                    />
                                    <Input
                                        required={true}
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        placeholder="Confirmez votre mot de passe"
                                        onChange={formikStep3.handleChange}
                                        onBlur={formikStep3.handleBlur}
                                        value={formikStep3.values.confirmPassword}
                                        errorMessage={
                                            formikStep3.touched.confirmPassword && formikStep3.errors.confirmPassword ? formikStep3.errors.confirmPassword : ""
                                        }
                                    />
                                    <Checkbox
                                        className="mt-1"
                                        label="J'accepte les Conditions Générales d'Utilisation"
                                        onChange={() => setIsTermsAccepted(!isTermsAccepted)}
                                        checked={isTermsAccepted}
                                    />
                                    <div
                                        className="mb-1 recaptcha-resend"
                                        id="recaptcha-container">
                                    </div>

                                    <div
                                        className={`mt-1 d-flex justify-content-${!steps[0].isCurrent ? "between" : "center"} w-100`}>
                                        {!steps[0].isCurrent && (
                                            <Button
                                                className="mb-1 font-S"
                                                label={"Retour"}
                                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                                onClick={() => handlePreviousStep()}
                                                style={Button_Style.OUTLINED}
                                            />
                                        )}
                                        <Button
                                            className="m-auto mb-1"
                                            buttonType={"submit"}
                                            label={"S'inscrire"}
                                            type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                            disabled={(!formikStep3.isValid && formikStep3.dirty) && !isTermsAccepted}
                                            icon={<IconCheck className="PageHeader__icon" fill={"#ffffff"} />}
                                        />
                                    </div>
                                </form>
                            )}
                        </div>
                        <div className="mt-auto mt-1">
                            {isLoading && <Loader text=""></Loader>}
                            <Button
                                label="Je suis déjà inscrit"
                                buttonType="button"
                                onClick={() => navigate(`/${userType == "partner" ? "professionnels" : "particuliers"}/login`)}
                                className="m-auto"
                                type={Button_Type.LABEL}
                            />
                        </div>
                    </div>
                    <TermsAgreement />
                    <br/><br/>
                </>
            ) : (
                <ConfirmPhone
                    ConfirmationResult={final}
                    phoneNumber={getFullPhoneNumber(formikStep2.values.phoneNumber)}
                    showConfirmPhone={() => setshowConfirmPhone(false)}
                    showConfirmEmail={showConfirmEmail}
                    setConfirmEmailMessage={setConfirmEmailMessage}
                    RegistrationData={RegistrationData}
                />
            )}
        </>
    );
};


export default RegisterForm;
